export default __webpack_public_path__ + "static/Blue_sky-6197d93c137b18c477f43e379c6fd3fb.png";